import {
  AEMErrorMessage,
  AEMErrorMessagesSection
} from '@com-delta-idp/mnx-skymiles-shared';
import { AEMFullPageErrorMessageMocks } from '../messages/full-page.mocks';

export const AEMErrorMessagesMocks: AEMErrorMessage[] = [
  AEMFullPageErrorMessageMocks
];

export const AEMErrorMessagesSectionMocks: AEMErrorMessagesSection = {
  errorMessagesSection: {
    errormessages: AEMErrorMessagesMocks
  }
};
